import React, { useState, useContext } from 'react'
import '../styles/componentsStyles/TabAdder.scss'
import axios from 'axios';
import { BASE_URL } from '../api/api';
import { toast } from 'react-toastify';

import { EditTabNameDisplay } from '../context/EditTabNameDisplay'
import { TabData } from '../context/TabData'

import Bin from "../assets/icons/delete.svg"
import Warning from "../assets/icons/warning.svg"

const EditTabName = () => {
    const [newTabName, setNewTabName] = useState("");
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const notifySomethingWrong = () => toast("⚠️ Something Went Wrong, Try Again!");
    const notifyTabDeleted = () => toast("✔️ Tab Deleted");

    // Contexts
    const editTabNameDisplay = useContext(EditTabNameDisplay);
    const tabData = useContext(TabData);

    const closeEditTabForm = () => {
        editTabNameDisplay.showEditTabNameFormDispatch({ type: 'closeEditTabNameForm' })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Note:: verify the user via server (once again, becoz we already did that is why edit option is showing up), that he is owner or not then only allow him to edit

        await axios.put(`${BASE_URL}/api/tabs/${tabData.updatedTabDataState.id}`, { title: newTabName })
            .then(res => {
                console.log(res, "Edit tab response")
                if (res.data.statusText === "success") {
                    // Close the Tab name editing form
                    editTabNameDisplay.showEditTabNameFormDispatch({ type: 'closeEditTabNameForm' });
                    // Re-render tablist after successfully editing tab name 
                    tabData.tabDataReducerDispatch({ type: 'reRenderTabList' });
                } else {
                    notifySomethingWrong();
                }
            }
            )
            .catch(err => {
                notifySomethingWrong();
                console.log(err, "Error! fetching Tabs")
            })
    }


    const deleteTabConfirmation = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDeleteConfirmation(true);
    }

    const deleteTab = async () => {
        setDeleteConfirmation(false);

        await axios.delete(`${BASE_URL}/api/tabs/${tabData.updatedTabDataState.id}`)
            .then(res => {
                console.log(res, "Delete tab response");
                if (res.data.statusText === "success") {
                    // Close the Tab name editing form
                    editTabNameDisplay.showEditTabNameFormDispatch({ type: 'closeEditTabNameForm' });
                    // Re-render tablist after successfully editing tab name 
                    tabData.tabDataReducerDispatch({ type: 'reRenderTabList' });
                    notifyTabDeleted();
                } else {
                    notifySomethingWrong();
                }
            }
            )
            .catch(err => {
                notifySomethingWrong();
                console.log(err, "Error! fetching Tabs")
            })
    }

    const cancelDelete = () => {
        setDeleteConfirmation(false);
    }
    return (
        <div className='tab-adder'>
            <form className="tab-adder__container" onSubmit={handleSubmit}>
                <h4><span>Edit Tab </span> <button onClick={deleteTabConfirmation} className='tab-adder__delete-tab-btn'>
                    <img src={Bin} alt="delete" />
                </button></h4>
                <input type="text" maxLength={50} placeholder='Rename Your Tab' value={newTabName} onChange={(e) => {
                    setNewTabName(e.target.value)
                }} autoFocus required />
                <button className='tab-adder__submit-btn' type='submit'>Rename Tab</button>

                <button className='tab-adder__close-btn' onClick={closeEditTabForm}>
                    <span className="material-symbols-outlined">
                        close
                    </span>
                </button>
            </form>
            {
                deleteConfirmation && <div className="tab-adder__delete-tab-btn-container">
                    <h5><img src={Warning} alt="warning" /><span>Warning!</span></h5>
                    <p><span> {tabData.updatedTabDataState.tabName}</span> Tab along with all its content will be permanently <b>Deleted</b> and cannot be retrieved in future.</p>
                    <div className="tab-adder__delete-tab-btn-group">
                        <button onClick={deleteTab}>I understand, Delete</button>
                        <button onClick={cancelDelete}>Cancel</button>
                    </div>
                </div>
            }

        </div >
    )
}

export default EditTabName